import {
  getEquipmentCategoriesList,
  welnetLogin,
  welnetToken,
} from "@/services";

export const shouldRunWelnetAuthentication = (user) =>
  user?.user_role?.slug === "user";

const getWelnetRedirectUri = (loginResponse) =>
  loginResponse?.payload?.data?.redirect_uri ||
  loginResponse?.payload?.redirect_uri;

/**
 * After a successful login, check whether the account is Welnet-only and
 * either redirect externally or continue with the normal in-app login flow.
 */
export const runWelnetAuthentication = ({
  dispatch,
  email,
  onComplete,
  onExternalRedirect,
}) => {
  return dispatch(getEquipmentCategoriesList()).then((categoriesResponse) => {
    const parentCategoryList = categoriesResponse?.payload?.data?.filter(
      (item) => !item?.parent_id,
    );
    const parentCategories = parentCategoryList?.map((category) => category?.slug);
    const isWelnetOnlyAccount =
      parentCategories?.length === 1 && parentCategories?.includes("welnet");

    if (!isWelnetOnlyAccount) {
      onComplete();
      return;
    }

    return dispatch(welnetToken({ data: { email } })).then((tokenResponse) => {
      if (!tokenResponse?.payload?.access_token) {
        onComplete();
        return;
      }

      return dispatch(
        welnetLogin({
          data: { accessToken: tokenResponse.payload.access_token },
        }),
      ).then((loginResponse) => {
        const redirectUri = getWelnetRedirectUri(loginResponse);

        if (redirectUri) {
          onExternalRedirect(redirectUri);
        } else {
          onComplete();
        }
      });
    });
  });
};
